import { NgModule } from '@angular/core';
import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { SharedModule } from '@app/shared/module';

import { AppRoutingModule } from './app.routing';
import { AppComponent } from './app.component';

registerLocaleData(localeEs);

@NgModule({
	declarations: [
		AppComponent
	],
	imports: [
		BrowserModule,
		BrowserAnimationsModule,

		SharedModule,

		AppRoutingModule
	],
	providers: [
	],
	bootstrap: [
		AppComponent
	]
})
export class AppModule { }
